import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper, Grid } from "@material-ui/core";
import { Title } from "App/Component/ui";

import { DataBarang, Perhitungan, FormPo } from "./ui";
import { FormContext, FormProvider } from "./context/FormContext";
import {
  FORM_RESET_STATE_WMS_PO,
  getPoListById,
  RenderListPo,
} from "./helpers";
import { RESET_STATE_PO_BARANG } from "./ui/DataBarang/helpers";
import { WMS_LGS_PO } from "App/constants";
import { isNull } from "App/utils/helpers";
import Export from "./ui/Export";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function PurchaseOrderLogistik(props) {
  const classes = useStyles();
  return (
    <FormProvider
      data={
        isNull(props?.data)
          ? FORM_RESET_STATE_WMS_PO
          : props?.menu === WMS_LGS_PO
          ? props?.data
          : FORM_RESET_STATE_WMS_PO
      }>
      <div className={classes.root}>
        <Title title={"Purchase Order (PO) Logistik"} />
        <Paper className={classes.paper}>
          <FormPo />
          <div className='mt-2'></div>
          <RenderContent classes={classes} data={props?.data} />
        </Paper>
      </div>

      <Export />
    </FormProvider>

    // <></>
  );
}

const RenderContent = ({ classes, data }) => {
  const [formBarang, setFormBarang] = useState(RESET_STATE_PO_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  // const { formData } = useContext(FormContext);
  const [listPO, setListPO] = useState([]);
  const {setRowsRekomendasi} = useContext(FormContext);
  
  useEffect(() => {
   setNewDataPoList(data.idpo);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPoList = async (idPo) => {
    if (!isNull(data)) {
      await getListPo(idPo);
    } else if (!isNull(idPo)) {
      await getListPo(idPo);
    }
  };

  const getListPo = async (idPo) => {
    if (!isNull(idPo)) {
      const res = await getPoListById(idPo);
      if (res.state) {
        setListPO(res.data.detail);
        setRowsRekomendasi(res.data.barang);
      } else {
        setListPO([]);
        setRowsRekomendasi([])
      }
    }
  };

  return (
    <>
      <RenderListPo
        classes={classes}
        formBarang={formBarang}
        setFormBarang={setFormBarang}
        showModalBarang={showModalBarang}
        setShowModalBarang={setShowModalBarang}
        listPO={listPO}
        setListPO={setListPO}
        setNewDataPoList={setNewDataPoList}
      />
      <div>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6}>
            <DataBarang
              formBarang={formBarang}
              setFormBarang={setFormBarang}
              showModalBarang={showModalBarang}
              setShowModalBarang={setShowModalBarang}
              listPO={listPO}
              setListPO={setListPO}
              setNewDataPoList={setNewDataPoList}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Perhitungan
              setListPO={setListPO}
              listPO={listPO}
              // perhitungan={perhitungan}
              setNewDataPoList={setNewDataPoList}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
